import { render, staticRenderFns } from "./BulkUserChangeRole.vue?vue&type=template&id=2dbae57e&scoped=true&"
import script from "./BulkUserChangeRole.vue?vue&type=script&lang=js&"
export * from "./BulkUserChangeRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbae57e",
  null
  
)

export default component.exports